var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoTerraform = function SvgLogoTerraform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Terraform")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B42BC",
    fillRule: "evenodd",
    d: "M10 8v10.102l8.696 5.05V13.052L10 8Zm18.348 10.688-8.696-5.05v10.101l8.696 5.05V18.689ZM38 23.739l-8.7 5.05V18.689l8.7-5.05v10.101ZM28.348 40l-8.696-5.05V24.846l8.696 5.051V40Z",
    clipRule: "evenodd"
  })));
};
export default SvgLogoTerraform;